// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"502":"e9197291","635":"8a309a26"}[chunkId] + ".chunk.js";
};